import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";

const BlogSection = () => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [blogsPerPage, setBlogsPerPage] = useState(3);
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("sm")); // sm = 600px+

  const blogs = [
    {
      id: "1",
      title: "7-benefits-digital-signage",
      heading:
        "7 Top Benefits of Digital Signage Displays for Retail Campaigns in 2025",
      description:
        "Discover 7 key benefits of digital signage displays for retail in 2025: increased engagement, real-time updates, personalization, etc.",
      author: "Rubina",
      date: "May 13, 2025",
      image: "/assests/images/LandingPage/blogs/blog1/blog-title-img.webp",
    },
    {
      id: "2",
      title: "best-signage-retail-execution",
      heading:
        "5 Things to Consider for Choosing the Best Signage Campaign Execution Partner in India",
      description:
        "Discover 5 crucial factors for selecting the best signage retail execution partner in India with the Pixell.",
      author: "Rubina",
      date: "May 14, 2025",
      image: "/assests/images/LandingPage/blogs/blog2/blog-title-img.webp",
    },
    {
      id: "3",
      title: "retail-signage-manufacturing",
      heading:
        "How Retail Signage Manufacturing Companies Drive ROI for Brands",
      description:
        "Discover how retail signage manufacturing drives measurable ROI through digital transformation, hyperlocal execution, and quality control. ",
      author: "Rubina",
      date: "May 15, 2025",
      image: "/assests/images/LandingPage/blogs/blog3/blog-title-img.webp",
    },
    {
      id: "4",
      title: "overcoming-transparency-issues-in-signage",
      heading:
        "How to Overcome Transparency Issues in Signage Production in 2025",
      description:
        "Discover effective transparent signage solutions to overcome transparency issues in signage production for 2025. ",
      author: "Rubina",
      date: "May 20, 2025",
      image: "/assests/images/LandingPage/blogs/blog4/blog-title-img.webp",
    },
    {
      id: "5",
      title: "10-Retail-Signage-Trends-for-2025",
      heading: "10 Must-Know Retail Signage Trends for 2025.",
      description:
        "Discover 2025's top retail signage trends including interactive displays, sustainable materials, AR integration and many more.",
      author: "Rubina",
      date: "May 22, 2025",
      image: "/assests/images/LandingPage/blogs/blog5/blog-title-img.webp",
    },
    {
      id: "6",
      title: "5-Multi-Location-Signage-Rollout-Challenges-and-Their-Solutions",
      heading:
        "5 Multi-Location Signage Rollout Challenges and Their Solutions",
      description:
        " Address the most common 5 Multi-Location Signage Rollout challenges  faced by brands and how to tackle them efficiently.",
      author: "Rubina",
      date: "May 28, 2025",
      image: "/assests/images/LandingPage/blogs/blog6/blog-title-img.webp",
    },
    // {
    //   id: "7",
    //   title: "7-Steps-to-Ensure-Compliance-with-2025-Signage-Regulations",
    //   heading: "7 Steps to Ensure Compliance with 2025 Signage Regulations",
    //   description:
    //     "Ensure your retail signage meets 2025 signage regulations with this step-by-step compliance guide and execute your retail campaign smoothly.",
    //   author: "Rubina",
    //   date: "June 3, 2025",
    //   image: "/assests/images/LandingPage/blogs/blog7/blog-title-img.webp",
    // },
    {
      id: "7",
      title: "How-LED-Display-Technology-Is-Transforming-Digital-Signage",
      heading: "How LED Display Technology Is Transforming Digital Signage",
      description:
        "Discover how LED Display technology transforms digital signage for retail stores through smart signage solutions.",
      author: "Rubina",
      date: "June 10, 2025",
      image: "/assests/images/LandingPage/blogs/blog8/blog-title-img.webp",
    },
    {
      id: "8",
      title:
        "How-to-Enhance-Customer-Engagement-with-Interactive-Signage-in-2025",
      heading:
        "How to Enhance Customer Engagement with Interactive Signage in 2025",
      description:
        "Explore key trends for 2025, from AI personalisation to AR, and learn how to implement these strategies for retail success.",
      author: "Rubina",
      date: "Sept 2, 2025",
      image: "/assests/images/LandingPage/blogs/blog9/Picture1.webp",
    },
    {
      id: "9",
      title: "6-Essential-Project-Management-Tips-to-Navigate-Custom-Signage",
      heading: "6 Essential Project Management Tips to Navigate Custom Signage",
      description:
        "Discover six essential tips for effective project management, from planning to installation, and ensure your project's success.",
      author: "Rubina",
      date: "Sept 4, 2025",
      image: "/assests/images/LandingPage/blogs/blog10/Picture1.webp",
    },
    {
      id: "10",
      title: "The-Impact-of-Creative-Signage-Ideas-on-Customer-Engagement",
      heading: "The Impact of Creative Signage Ideas on Customer Engagement",
      description:
        "Discover how creative signage ideas boost customer engagement. Learn how Pixell’s BTL marketing expertise ensures flawless execution of interactive, attention-grabbing signages across retail campaigns.",
      author: "Rubina",
      date: "Sept 16, 2025",
      image: "/assests/images/LandingPage/blogs/blog11/Picture1.webp",
    },
    {
      id: "11",
      title: "The-Role-of-Augmented-Reality-in-Modern-Retail-Signage-in-2025",
      heading: "The Role of Augmented Reality in Modern Retail Signage in 2025",
      description:
        "Learn how modern retailers use augmented reality signage to create immersive in-store experiences and achieve flawless execution in 2025.",
      author: "Rubina",
      date: "Oct 08, 2025",
      image: "/assests/images/LandingPage/blogs/blog12/picture1.webp",
    },
    {
      id: "12",
      title: "The_Hidden_Cost_of_Inconsistent_Branding_in_Kirana_Stores",
      heading: "The Hidden Cost of Inconsistent Branding in Kirana Stores",
      description:
        "Discover the hidden cost of inconsistent branding in kirana stores and how poor retail signage impacts brand trust, sales, and perception. ",
      author: "Rubina",
      date: "Oct 27, 2025",
      image: "/assests/images/LandingPage/blogs/blog13/picture1.webp",
    },
  ];

  // Set number of blogs per page based on screen size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setBlogsPerPage(1);
      } else if (window.innerWidth < 1024) {
        setBlogsPerPage(2);
      } else {
        setBlogsPerPage(3);
      }
    };
    handleResize(); // Set initially
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sortedBlogs = [...blogs].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const totalPages = Math.ceil(sortedBlogs.length / blogsPerPage);
  const startIdx = (currentPage - 1) * blogsPerPage;
  const currentBlogs = sortedBlogs.slice(startIdx, startIdx + blogsPerPage);

  return (
    <div className=" px-6 py-12">
      <div className="text-center mb-12">
        <h5 className="text-sm uppercase text-gray-500 mb-2">Our Blog</h5>
        <h2 className="text-xl md:text-4xl font-bold">
          Discover Our Latest Articles
        </h2>
      </div>

      <div className="max-w-7xl mx-auto grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {currentBlogs.map((blog, idx) => (
          <div
            key={idx}
            className="bg-[#1e293b] transition-colors duration-300 rounded-xl shadow-md p-4 max-w-sm h-[460px] flex flex-col justify-between overflow-hidden"
          >
            <img
              src={blog.image}
              alt={blog.title}
              className="rounded-md mb-4 w-full h-[200px] object-contain"
            />
            <h2 className="text-white text-lg font-bold mb-2">
              {blog.heading}
            </h2>
            <p className="text-slate-300 text-sm mb-4 line-clamp-3">
              {blog.description}
            </p>
            <div className="flex justify-between items-center gap-2 mt-auto">
              <div>
                <p className="text-white text-sm">{blog.author}</p>
                <p className="text-slate-400 text-xs">{blog.date}</p>
              </div>
              {/* <button
                type="button"
                onClick={() => navigate(`/blogs/${blog.title}`)}
                className="text-white bg-[#1e293b] hover:bg-white hover:text-[#1e293b] border-2 border-white-500 cursor-pointer font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
              >
                Read More
                <svg
                  className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 5h12m0 0L9 1m4 4L9 9"
                  />
                </svg>
              </button> */}
              <Link
                to={`/blogs/${encodeURIComponent(blog.title)}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white bg-[#1e293b] hover:bg-white hover:text-[#1e293b] border-2 border-white cursor-pointer font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                aria-label={`Read more about ${blog.title}`}
              >
                Read More
                <svg
                  className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 10"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M1 5h12m0 0L9 1m4 4L9 9"
                  />
                </svg>
              </Link>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && (
        <div className="mt-10 mx-2 flex justify-center pb-10">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={(e, value) => setCurrentPage(value)}
              color="primary"
              shape="rounded"
              size={isLargeScreen ? "medium" : "small"}
            />
          </Stack>
        </div>
      )}
    </div>
  );
};

export default BlogSection;
